import {
  ChangeDetectorRef,
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { CityMapService } from 'src/app/services/city-map.service';
import { MapService } from 'src/app/services/map.service';
import { ActivatedRoute, Router } from '@angular/router';
import { biomeRanges, elevationRanges } from 'src/app/constant/constant';
import { CoordinatesService } from 'src/app/services/coordinates.service';
import { CreateGameInvitationModalComponent } from '../active-games/create-game-invitation-modal/create-game-invitation-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { combineLatest, of, Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { ConfirmModalComponent } from 'src/app/modal/confirm-modal/confirm-modal.component';
import { CityWebDataService } from 'src/app/services/city-web-data.service';
import { CellDetails } from 'src/app/models/cell-details.model';
import { PlayerStoryComponent } from 'src/app/modal/player-story/player-story.component';
import { ToastService } from 'src/app/services/toast.service';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { NoteListComponent } from 'src/app/modal/note-list/note-list.component';
import { MapDataService } from 'src/app/services/map-data.service';
import { WikiService } from 'src/app/services/wiki.service';
import { FavoriteRecord } from '../content-creator/add-content/models/content.model';
import { FavoriteRecordsService } from 'src/app/services/favorite-records.service';
import { ContentData } from '../content-creator/add-content/models/content.model';
import { PlaceContentModalComponent } from 'src/app/modal/place-content-modal/place-content-modal.component';
import { StoreLinkService } from 'src/app/services/marketplace/store-link.service';

@Component({
  selector: 'app-city-map-view',
  templateUrl: './city-map-view.component.html',
  styleUrls: ['./city-map-view.component.scss'],
  standalone: false
})
export class CityMapViewComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    private cityMapService: CityMapService,
    private mapService: MapService,
    private router: Router,
    private currentUserService: CurrentUserService,
    private activatedRoute: ActivatedRoute,
    private coordinateService: CoordinatesService,
    private modalService: NgbModal,
    private dataService: DataService,
    private storeLinks: StoreLinkService,
    private coordinatesService: CoordinatesService,
    private cityFetchService: CityWebDataService,
    private toastService: ToastService,
    private cityDataService: CityWebDataService,
    private mapDataService: MapDataService,
    private favoriteRecordsService: FavoriteRecordsService,
    private wikiService: WikiService,
    private cdr: ChangeDetectorRef,
  ) { }

  @ViewChild('cityMap') cityMap: ElementRef;

  citycode = '';
  mapcode = '';
  character_id: string = '';
  game_id: string = '';
  backRoute: string = '';
  map_name: string = '';
  backWordNavigateUrl: string = '';
  showDropdown = false;
  isCreateGame = false;
  historyAllRecords: any[] = [];

  mapObject: any;
  startLocation: any;
  historyCityRecords: any[] = [];
  burgData: any;
  objectData: any;

  cityMapCoordsSubscription: Subscription;
  isAcceptBtn: boolean = false;
  playerOuterCoordinateSubscription: Subscription;
  outerPartyCoordinates: any;
  isLoadToken: boolean = false;
  isCultureVisible: boolean = true;
  isMapDetailsVisible = true;
  isCityDetailsVisible = true;
  activateRouteSubscribtion: Subscription;
  paramsSubscription: Subscription;
  cityContentCreatorData: ContentData[] = [];
  coordsArrOfPointsUserCity: any[] = [];
  sideInfoBar: boolean;
  map_genre: string;
  wholeData: CellDetails;
  cityData: any;
  cellDetailsOrder: string[] = [
    'City Present',
    'Elevation',
    'Depth',
    'Population',
    'State',
    'Province',
    'Culture',
    'Religion',
    'Biome',
    'Land Area',
    'Geozone',
    'Natural Resources',
    'Bonus Resources',
    'Farm Resources',
    'Mineral Resources',
    'Special Resources',
  ];

  cityDetailsSortArray: string[] = [
    'City Name',
    'Population',
    'District',
    'Capitol',
    'Port',
    'Citadel',
    'City Walls',
    'Market Place',
    'Religious Center',
    'Shanty Town',
  ];
  selectedOption: string = '';
  historySubscription: Subscription;
  routerSubscription: Subscription;
  showItemDetailsBox: boolean = false;
  isMovable: boolean = false;
  userId: string | number = '';
  coordsArrOfPointsMapCodeCityCodeCity: { coords: [number, number][], idArr: number[], content: ContentData[] } = { coords: [], idArr: [], content: [] };
  cityContentPlayersData: any[] = [];
  menuPosition = { x: 0, y: 0 };
  showMenu: boolean = false;
  newClickedCoordinates: [number, number] | null = null;
  atBoundary: boolean = false;
  cityBoundarySubscription: Subscription;
  playInterval: any;
  mapListSubscription: Subscription;
  mapListData: any[] = [];
  elevationRanges = elevationRanges;
  biomeRanges = biomeRanges;
  game_system: string | null = null;
  headerTitle: string = '';
  characterdetails: any;
  redirect_coords: string | null = null;
  favoriteList: FavoriteRecord[] = [];
  isRemovingFavorite: number | null = null;

  ngOnInit(): void {
    history.pushState(null, '', location.href);
    window.onpopstate = () => {
      history.go(1); // disables going back
    };
  }

  ngAfterViewInit(): void {
    this.extractRouteParams();
    this.intializeCityMapSubscription();
  }

  createContent() {
    const elevationRanges = this.buildElevationRange(this.wholeData);
    const biomeRanges = this.processBiomeRanges(this.wholeData);
    this.buildUrbanLocationRange(this.wholeData);
    const rangeObject = {
      elevation: elevationRanges,
      biome: biomeRanges,
    };
    if (this.game_system) rangeObject['game_system'] = this.game_system;
    this.passFinalObjectToContentPage(rangeObject);
  }

  passFinalObjectToContentPage(queryParamsObject: any) {
    this.mapDataService.setContentRangesData(queryParamsObject);
    this.router.navigate(['/add-edit-content'], {
      queryParams: {
        map_id: this.mapcode,
        character_id: this.character_id,
        citycode: this.citycode,
        backwordNavigate: this.router.url,
        coordinates: this.newClickedCoordinates?.join(','),
      },
    });
  }

  ngOnDestroy(): void {
    this.mapService.removeCityLayer();
    this.cityMapCoordsSubscription?.unsubscribe();
    this.activateRouteSubscribtion?.unsubscribe();
    this.playerOuterCoordinateSubscription?.unsubscribe();
    this.routerSubscription?.unsubscribe();
    this.historySubscription?.unsubscribe();
    this.cityBoundarySubscription?.unsubscribe();
    this.paramsSubscription?.unsubscribe();
    this.mapListSubscription?.unsubscribe();
    if (this.playInterval) clearInterval(this.playInterval);
  }

  extractRouteParams() {
    this.paramsSubscription = this.activatedRoute.params.subscribe((params) => {
      if (this.hasRequiredParams(params)) {
        this.assignParams(params);
        this.extractQueryParamsAndInitializeMap();
      }
    
          this.cdr.detectChanges();});
  }

  hasRequiredParams(params: any): boolean {
    return (
      (params['mapcode'] && params['citycode'] && params['game_id']) ||
      params['character_id']
    );
  }

  getUserId(map_name: string | null, isPlaceToken: any) {
    this.currentUserService.currentUser.subscribe((user) => {
      if (user) {
        this.userId = user.id;
        this.favoriteRecordsService.loadFavoriteRecords(this.userId, 'city', true);
        this.loadFavoriteRecords()
        if (this.character_id && !this.game_id) {
          this.charCurrentCityFetch(this.userId, isPlaceToken);
        } else if (this.game_id) {
          this.gameIdCurrentCityFetch(this.userId, isPlaceToken);
        }
        this.getAllCityContentRecordsOfMapCity();
        this.cdr.detectChanges();
      }
    });
  }

  loadFavoriteRecords() {
    this.favoriteRecordsService.favroiteCityRecords$.subscribe((data) => {
      this.favoriteList = data || [];
      this.isRemovingFavorite = null;
      this.cdr.detectChanges();
    });
  }

  private charCurrentCityFetch(user_id: string | number, isPlaceToken) {
    this.cityFetchService
      .charCurrentCity(user_id, this.character_id)
      .subscribe({
        next: (res: { character_id: any; city_code: any }) => {
          if (res.city_code !== this.citycode || !res.city_code) {
            this.isNeedToCallCityEnter(true, isPlaceToken);
          } else {
            this.checkIsAskToPlaceToken(isPlaceToken, true);
          }
        
          this.cdr.detectChanges();},
      });
  }

  private gameIdCurrentCityFetch(user_id: any, isPlaceToken: any) {
    this.cityFetchService.gameCurrentCity(this.game_id).subscribe({
      next: (res: { game_id: any; city_code: any }) => {
        if (res.city_code !== this.citycode || !res.city_code) {
          this.isNeedToCallCityEnter(true, isPlaceToken);
        } else {
          this.checkIsAskToPlaceToken(isPlaceToken, false);
        }
      
          this.cdr.detectChanges();},
    });
  }

  checkIsAskToPlaceToken(isPlaceToken, isCharId?: boolean) {
    if (isCharId) {
      this.cityDataService
        .checkCurrentCityChildrenForCharacter(this.character_id, this.mapcode)
        .subscribe({
          next: (res: {
            has_children: boolean;
            last_map_id: number;
            last_map_timestamp: string;
          }) => {
            if (res.has_children) {
              this.isNeedToCallCityEnter(false, isPlaceToken, true);
            } else {
              this.isNeedToCallCityEnter(true, isPlaceToken, true);
            }
          
          this.cdr.detectChanges();},
        });
    } else {
      this.cityDataService
        .checkCurrentCityChildrenForGame(this.game_id, this.mapcode)
        .subscribe({
          next: (res: {
            has_children: boolean;
            last_map_id: number;
            last_map_timestamp: string;
          }) => {
            if (res.has_children) {
              this.isNeedToCallCityEnter(false, isPlaceToken, true);
            } else {
              this.isNeedToCallCityEnter(true, isPlaceToken, true);
            }
          
          this.cdr.detectChanges();},
        });
    }
  }

  isNeedToCallCityEnter(call: boolean, isPlaceToken, haltCall?: boolean) {
    if (call) {
      if (this.isLoadToken && this.isMovable) {
        if (this.backRoute !== 'mapview' && !haltCall) {
          this.callCityEnter(false);
        } else if (this.backRoute == 'mapview' && !haltCall) {
          this.callCityEnter(true);
        }
      }

      this.mapService.citydataload(
        this.citycode,
        this.mapcode,
        this.isLoadToken,
        isPlaceToken,
        this.backRoute === 'mapview',
        this.backRoute === 'mapview' ? this.game_id : this.character_id,
        this.isMovable,
        true,
      );
      if (this.redirect_coords) {
        this.mapService.zoomToRedirectCoordsCity(this.redirect_coords);
      }
    } else {
      this.mapService.citydataload(
        this.citycode,
        this.mapcode,
        this.isLoadToken,
        isPlaceToken,
        this.backRoute === 'mapview',
        this.backRoute === 'mapview' ? this.game_id : this.character_id,
        this.isMovable,
        false,
      );
      if (this.redirect_coords) {
        this.mapService.zoomToRedirectCoordsCity(this.redirect_coords);
      }
    }
  }

  onRightClickPopup(event: MouseEvent) {
    event.preventDefault(); // Prevent the default context menu

    // keep the menu on screen near the right/bottom edges
    this.menuPosition.x = Math.min(event.clientX, window.innerWidth - 260);
    this.menuPosition.y = Math.min(event.clientY, window.innerHeight - 200);

    this.showMenu = true;

    this.newClickedCoordinates = this.mapService.map1.getEventCoordinate(
      event,
    ) as [number, number];
  }

  getAllCityContentRecordsOfMapCity() {
    this.cityDataService
      .getContentCityByMapCodeCityId(this.userId, this.mapcode, this.citycode)
      .subscribe((data: any) => {
        if (data.results && data.results.length > 0) {
          this.cityContentCreatorData = data.results;
          this.coordsArrOfPointsMapCodeCityCodeCity =
            this.extractCoordinatesFromPins(this.cityContentCreatorData);

          this.mapService.addDifferentContentPinCity(
            false,
            this.coordsArrOfPointsMapCodeCityCodeCity,
            true,
          );
        } else {
          this.cityContentCreatorData = [];
        }
        this.cdr.detectChanges();
      }, (error) => {
        console.error('Error fetching city content records:', error);
        this.toastService.showSuccess("We couldn't load this city's content.", 'danger');
      
          this.cdr.detectChanges();});
  }

  private extractCoordinatesFromPins(contentData: ContentData[]): { coords: [number, number][], idArr: number[], content: ContentData[] } {
    const coords: [number, number][] = [];
    const idArr: number[] = [];
    const content: ContentData[] = [];
    (contentData || [])
      .filter((ele) => ele.pins && ele.pins.length > 0)
      .forEach((ele) => {
        ele.pins
          .filter((pin) => String(pin.map_id) === String(this.mapcode) && String(pin.city_id) === String(this.citycode))
          .forEach((pin) => {
            coords.push([
              parseFloat(pin.latitude as any),
              parseFloat(pin.longitude as any),
            ]);
            idArr.push(pin.id);
            content.push(ele);
          });
      });
    return { coords, idArr, content };
  }

  assignParams(params: any) {
    this.citycode = params['citycode'];
    this.mapcode = params['mapcode'];
    this.mapListSubscription = this.mapService.mapList$.subscribe(
      (data: any) => {
        if (data) {
          this.mapListData = data;
          this.getMapName(this.mapcode);
        } else {
          this.mapService.getMapList();
        }
        this.cdr.detectChanges();
      },
    );

    this.game_id = this.normalizeParam(params['game_id']);
    if (this.game_id) {
      this.sendCurrentTimeOfPlay(this.game_id);
      this.playInterval = setInterval(() => {
        this.sendCurrentTimeOfPlay(this.game_id);
      }, 100000);
    }
    this.character_id = this.normalizeParam(params['character_id']);
    if (this.character_id && this.game_id) {
      this.headerTitle =
        'During active play, Game Master controls token movement.';
    }
    this.getBurgData(this.mapcode, this.citycode);
    this.fetchMapCityData();

    this.mapService.mapCodeDataContainer ||= {};
    this.mapService.mapCodeDataContainer.game_id = this.game_id;
    this.mapService.mapCodeDataContainer.character_id = this.character_id;
  }

  normalizeParam(value: string): string | null {
    return value === 'null' || value === 'undefined' ? null : value;
  }

  getBurgData(mapcode: any, citycode: any) {
    this.dataService
      .getBurgsData(mapcode, citycode)
      .subscribe((data: { res: any }) => {
        if (data?.res.length > 0) {
          this.burgData = data.res[0];
          this.cdr.detectChanges();
        }
      });
  }

  extractQueryParamsAndInitializeMap() {
    combineLatest([
      this.activatedRoute.queryParamMap,
      this.character_id
        ? this.dataService.Getcharacterdetailbychar_id(this.character_id)
        : of(null),
    ]).subscribe(
      ([params, characterDetail]: [any, { character_details: any } | null]) => {
        const token = params.get('token');
        this.isLoadToken = params.get('isLoadToken') === 'true';
        if (params.get('isMovable')) {
          this.isMovable = params.get('isMovable') === 'true';
        } else this.isMovable = true;
        const isPlaceToken = params.get('isPlaceToken') || null;
        if (params.get('game_system') && params.get('game_system') !== 'null') {
          this.game_system = params.get('game_system');
        }
        if (params.get('redirect_coords') && params.get('redirect_coords') !== 'null') {
          this.redirect_coords = params.get('redirect_coords');
        }
        this.map_genre = params.get('map_genre') || null;

        if (token) {
          this.mapService.userProfileUrl = token;
        }
        if (characterDetail?.character_details) {
          this.characterdetails = characterDetail.character_details;
        }

        this.backRoute = params.get('backRoute') || '';

        this.setupBackNavigation(token);
        if (
          characterDetail &&
          !characterDetail.character_details.city_id &&
          this.game_id &&
          this.isLoadToken
        ) {
          this.bounceBackToMainMap();
          return;
        }
        this.restoreMapObjectFromLocalStorage();

        this.mapService.map1.setTarget(this.cityMap.nativeElement);

        this.historyCityRecordsdata();
        this.historyAllDataRecords();
        this.getUserId(this.map_name, isPlaceToken);

        if (!this.isLoadToken) {
          this.mapService.citydataload(
            this.citycode,
            this.mapcode,
            this.isLoadToken,
            isPlaceToken,
            this.backRoute === 'mapview',
            this.backRoute === 'mapview' ? this.game_id : this.character_id,
            this.isMovable,
            false,
          );
          if (this.redirect_coords) {
            this.mapService.zoomToRedirectCoordsCity(this.redirect_coords);
          }
        }
        this.cdr.detectChanges();
      },
    );
  }

  bounceBackToMainMap() {
    this.router.navigate([this.backWordNavigateUrl]);
  }

  callCityEnter(isParty: boolean) {
    if (!isParty) {
      this.cityMapService
        .markCharacterInOutInCity(
          this.mapcode,
          this.character_id,
          this.citycode,
        )
        .subscribe((res) => {
          if (res) {
            this.activateRouteSubscribtion?.unsubscribe();
            this.paramsSubscription?.unsubscribe();
            this.updateLocalStorageObject();
          }
        
          this.cdr.detectChanges();});
    } else {
      this.cityMapService
        .markCharacterInOutInCityGameMaster(
          this.mapcode,
          this.game_id,
          this.citycode,
        )
        .subscribe((res) => {
          if (res) {
            this.activateRouteSubscribtion?.unsubscribe();
            this.paramsSubscription?.unsubscribe();
            this.updateLocalStorageObject();
          }
        
          this.cdr.detectChanges();});
    }
  }

  updateLocalStorageObject() {
    localStorage.setItem(
      'cityToggleObject',
      JSON.stringify({
        mapcode: this.mapcode,
        citycode: this.citycode,
        currentTime: new Date().getTime(),
        character_id: this.character_id,
        game_id: this.game_id,
      }),
    );
  }

  setupBackNavigation(token: string) {
    if (this.backRoute === 'mapview') {
      this.backWordNavigateUrl = `/${this.backRoute}/${this.mapcode}/${this.game_id}`;
    } else if (this.backRoute.includes('creategame-mapview')) {
      this.backWordNavigateUrl = this.backRoute;
      this.isAcceptBtn = true;
      this.isCreateGame = true;
      this.mapService.cityMapBirthLocation(token, true);
    } else if (this.backRoute == 'map') {
      this.backWordNavigateUrl = this.backRoute + `/${this.mapcode}`;
    } else {
      this.backWordNavigateUrl = `/${this.backRoute}/${this.mapcode}/${this.game_id ?? 'null'
        }/${this.character_id}`;
    }
  }

  restoreMapObjectFromLocalStorage() {
    const mapObject = localStorage.getItem('mapObject');
    if (mapObject) {
      this.mapObject = JSON.parse(mapObject);
    }
  }

  intializeCityMapSubscription() {
    this.cityMapCoordsSubscription =
      this.cityMapService.cityMapCoordinates$.subscribe((value) => {
        if (Array.isArray(value)) {
          this.startLocation = value;
        }
      
          this.cdr.detectChanges();});
    this.playerOuterCoordinateSubscription =
      this.coordinatesService.playerOuterCoordinates$.subscribe(
        (coordinates) => {
          if (coordinates) {
            this.outerPartyCoordinates = coordinates;
          }
        
          this.cdr.detectChanges();},
      );

    this.cityBoundarySubscription =
      this.coordinateService.atCityBoundary$.subscribe((atBoundary) => {
        if (atBoundary) {
          this.atBoundary = true;
        } else {
          this.atBoundary = false;
        }
        this.cdr.detectChanges()
      });
  }

  historyCityRecordsdata() {
    this.historySubscription =
      this.coordinateService.historyCityRecords$.subscribe(
        (historyCityRecords) => {
          if (historyCityRecords) {
            this.historyCityRecords = [...historyCityRecords];
            this.sortHistoryRecords(this.historyCityRecords);
            if (this.backRoute !== 'mapview') {
              this.mapService.getPlayerAllHistoryData(
                this.character_id,
                this.mapcode,
              );
            } else {
              this.mapService.getAllGameMasterHistoryData(
                this.game_id,
                this.mapcode,
              );
            }
            this.mapService.addCityConstantLine(this.historyCityRecords, true);
          } else {
            this.historyCityRecords = [];
          }
          this.cdr.detectChanges();
        },
      );
  }

  historyAllDataRecords() {
    this.coordinateService.historyRecords$.subscribe((historyAllRecords) => {
      if (historyAllRecords && typeof historyAllRecords === 'object') {
        this.historyAllRecords = [...historyAllRecords];
        this.historyAllRecords = this.historyAllRecords.map((item) => {
          item.selected = false;
          return item;
        });
      } else {
        this.historyAllRecords = [];
      }
      this.cdr.detectChanges();
    });
  }

  sortHistoryRecords(records: any[]) {
    records.sort((a, b) => {
      return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
    });
  }

  selectOption(option: string) {
    this.showDropdown = false;
  }

  openGameCreateInvitationModal() {
    const modalRef = this.modalService.open(
      CreateGameInvitationModalComponent,
      {
        size: 'lg',
        backdrop: 'static',
        centered: true,
      },
    );

    modalRef.componentInstance.spawn_location = this.startLocation?.join(',');
    modalRef.componentInstance.map_id = this.mapcode;
    modalRef.componentInstance.city_id = this.citycode;
    modalRef.componentInstance.map_genre = this.map_genre;

    modalRef.componentInstance.outerPartyCoordinates =
      this.outerPartyCoordinates?.join(',');
    modalRef.componentInstance.map_name = this.map_name;

    modalRef.result.then((result) => {
      if (result) {
        this.router.navigate(['/activegames']);
      }
    
          this.cdr.detectChanges();});
  }

  /** Exit city: only once the party token stands at the city's edge. */
  onExitCity(event: Event) {
    if (!this.isMovable) {
      this.toastService.showNote("The party token can't move right now, so it can't leave the city.", 'warning');
      return;
    }
    if (!this.atBoundary) {
      this.toastService.showNote('Move the party token to the edge of the city first, then choose Exit city.', 'warning');
      return;
    }
    this.removeCityLayer(event);
  }

  removeCityLayer(event) {
    window.onpopstate = null;
    event.preventDefault();

    if (!this.isLoadToken) {
      if (this.backWordNavigateUrl !== '') {
        this.router.navigate([this.backWordNavigateUrl]);
        return;
      }
      window.history.back();
      return;
    }
    if (!this.isMovable && this.backRoute !== 'mapview') {
      this.router.navigate(['char-portfolio']);
      return;
    }
    const backRoute = this.backRoute;
    if (this.isLoadToken && (this.mapcode || this.character_id)) {
      const modalRef = this.modalService.open(ConfirmModalComponent, {
        backdrop: 'static',
        keyboard: false,
        centered: true,
      });
      const cityName = this.cityData?.['City Name'] && this.cityData['City Name'] !== 'NA' ? this.cityData['City Name'] : 'this city';
      modalRef.componentInstance.title = `Leave ${cityName}?`;
      modalRef.componentInstance.message = 'You will go back to the world map.';
      modalRef.componentInstance.confirmLabel = 'Yes, Leave';
      modalRef.componentInstance.confirmVariant = 'theme';
      modalRef.componentInstance.confirmClick.subscribe(() => modalRef.close(true));

      modalRef.result.then((confirmed) => {
        if (confirmed) {
          const apiCall =
            backRoute === 'mapview'
              ? this.cityMapService.markCharacterInOutInCityGameMaster(
                this.mapcode,
                this.game_id,
                null,
              )
              : this.cityMapService.markCharacterInOutInCity(
                this.mapcode,
                this.character_id,
                null,
              );

          apiCall.subscribe((res) => {
            if (res) {
              this.resetToggleObject();
              this.mapService.removeCityLayer();
              this.router.navigate([this.backWordNavigateUrl], {
                queryParams: {
                  isCityExited: true,
                },
              });
            }
          
          this.cdr.detectChanges();});
        }
      
          this.cdr.detectChanges();});
    } else {
      window.history.back();
    }
  }

  resetToggleObject() {
    const cityToggleJSON = localStorage.getItem('cityToggleObject');
    if (cityToggleJSON) {
      const cityToggleObject = JSON.parse(cityToggleJSON);
      cityToggleObject.citycode = null;
      localStorage.setItem(
        'cityToggleObject',
        JSON.stringify(cityToggleObject),
      );
    }
  }

  toggleCultureList() {
    this.isCultureVisible = !this.isCultureVisible;
  }

  toggleMapDetails() {
    this.sideInfoBar = true;
    this.isMapDetailsVisible = !this.isMapDetailsVisible;
    return this.sideInfoBar;
  }

  fetchMapCityData() {
    this.cityFetchService
      .getMapCityData(this.mapcode, this.citycode)
      .subscribe((data: CellDetails) => {
        if (data) {
          this.wholeData = data;
          this.processMapDetailsAndCityData(data);
          this.cdr.detectChanges();
        }
      });
  }
  processMapDetailsAndCityData(data: CellDetails) {
    this.objectData = {
      'City Present': data.burg ? 'Yes' : 'None',
      State: data.state,
      Province: data.province,
      Culture: data.culture,
      Religion: data.religion,
      Biome: data.biome,
      Elevation: data.elevation + ' ft' || 'NA',
      Depth: data.depth + ' ft' || 'NA',
      Population: data.population,
      'Natural Resources': data.resources?.basic || [],
      'Bonus Resources': data.resources?.bonus || [],
      'Mineral Resources': data.resources?.mineral || [],
      'Farm Resources': data.resources?.farmed || [],
      'Special Resources': data.resources?.special || [],
    };
    if (this.objectData.Elevation === 'undefined ft' || this.objectData.Elevation === '0 ft') {
      delete this.objectData.Elevation;
    }
    if (this.objectData.Depth === 'undefined ft' || this.objectData.Depth === '0 ft') {
      delete this.objectData.Depth;
    }
    if (data.burgs_data) {
      this.cityData = {
        'City Name': data.burgs_data.Burg || 'NA',
        Capitol: data.burgs_data.Capital || 'No',
        Citadel: data.burgs_data.Citadel || 'No',
        Port: data.burgs_data.Port || 'No',
        'Market Place': data.burgs_data.Plaza || 'No',
        'City Walls': data.burgs_data.Walls || 'No',
        'Religious Center':
          data.burgs_data.Temple && data.burgs_data.Temple.length > 0
            ? 'Yes'
            : 'No',
        'Shanty Town':
          data.burgs_data['Shanty Town'] &&
            data.burgs_data['Shanty Town'].length > 0
            ? 'Yes'
            : 'No',
        Population: data.burgs_data.Population || data.population || 'NA', // Use city population if burg population is not available
      };
    } else {
      this.cityData = null; // Or an empty object if you prefer: {}
    }
    this.cdr.detectChanges();
  }

  cellDetailsSort = (a: any, b: any): number => {
    const order = this.cellDetailsOrder;
    const indexA = order.indexOf(a.key);
    const indexB = order.indexOf(b.key);
    // If not found, put at the end
    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  };

  cityDetailsSort = (a: any, b: any): number => {
    const order = this.cityDetailsSortArray;
    const indexA = order.indexOf(a.key);
    const indexB = order.indexOf(b.key);
    // If not found, put at the end
    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  };

  triggerZoomIn() {
    this.mapService.zoomInCity();
  }

  triggerZoomOut() {
    this.mapService.zoomOutCity();
  }
  triggerTokenZoom() {
    this.mapService.zoomToExtent('city-map');
  }
  editDetail(record, isCity) {
    const modalRef = this.modalService.open(PlayerStoryComponent, {
      size: 'md',
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.componentInstance.updateStory.details = record.details;
    modalRef.componentInstance.updateStory.title = record.title;
    modalRef.result.then((result) => {
      if (result) {
        const recordDetails = result.value.details;
        const recordTitle = result.value.title;

        if (this.backRoute === 'mapview') {
          if (!isCity) {
            record.details = result.value.details;
            record.title = result.value.title;
            this.dataService.updatepartylocationhistory(record).subscribe(
              (data) => {
                if (data) {
                  this.toastService.showSuccess(
                    'Game Party History Updated Successfully !!!',
                    'success',
                  );
                }
              
          this.cdr.detectChanges();},
              (error) => {
                record.details = recordDetails;
                record.title = recordTitle;
              
          this.cdr.detectChanges();},
            );
          } else {
            record.details = result.value.details;
            record.title = result.value.title;
            this.cityDataService.updateCityPartyJournal(record).subscribe(
              (data) => {
                if (data) {
                  this.toastService.showSuccess(
                    'City History Updated Successfully !!!',
                    'success',
                  );
                }
              
          this.cdr.detectChanges();},
              (error) => {
                record.city_details = recordDetails;
                record.city_title = recordTitle;
              
          this.cdr.detectChanges();},
            );
          }
        } else {
          if (!isCity) {
            record.details = result.value.details;
            record.title = result.value.title;
            this.dataService.updateHistoryRecord(record).subscribe(
              (data) => {
                if (data) {
                  this.toastService.showSuccess(
                    'Player History Updated Successfully !!!',
                    'success',
                  );
                }
              
          this.cdr.detectChanges();},
              (error) => {
                record.details = recordDetails;
                record.title = recordTitle;
              
          this.cdr.detectChanges();},
            );
          } else {
            record.details = result.value.details;
            record.title = result.value.title;

            this.cityDataService.updateCityMovmentHistory(record).subscribe(
              (data) => {
                if (data) {
                  this.toastService.showSuccess(
                    'City Party Journal Updated Successfully !!!',
                    'success',
                  );
                }
              
          this.cdr.detectChanges();},
              (error) => {
                record.details = recordDetails;
                record.title = recordTitle;
              
          this.cdr.detectChanges();},
            );
          }
        }
      }
    
          this.cdr.detectChanges();});
  }

  closeSecondMenu() {
    this.showItemDetailsBox = false;
    this.selectedOption = '';
  }

  openSideDropdownOption() {
    this.showDropdown = !this.showDropdown;
    this.selectedOption = '';
    this.showItemDetailsBox = false; // Toggles the dropdown visibility
  }

  setSelectOption(option: string) {
    this.selectedOption = option;
    this.showItemDetailsBox = true;
    this.showDropdown = false; // the list closes once a panel is chosen
  }

  handleOnlyBack() {
    this.mapService.removeCityLayer();
    if (!this.backWordNavigateUrl) {
      return;
    }

    const isLoadToken = this.isLoadToken;

    let queryParams: any = {
      isonlyback: isLoadToken,
      displayHeader: isLoadToken,
    };

    if (!isLoadToken) {
      queryParams.isCityVisited = true;
    }
    if (this.characterdetails?.is_in_city) {
      queryParams.displayHeader = true;
    }

    this.router.navigate([this.backWordNavigateUrl], {
      queryParams,
      queryParamsHandling: 'merge',
    });
  }

  sendCurrentTimeOfPlay(game_id) {
    this.dataService.sendCurrentTimeOfPlay(game_id).subscribe((data: any) => {
      if (data) {
      }
    
          this.cdr.detectChanges();});
  }

  handleMapviewExit() {
    window.onpopstate = null;

    if (this.backRoute === 'mapview') {
      this.router.navigate([`/activegames`]);
    } else if (this.backRoute == 'map-view-player') {
      this.router.navigate([`/char-portfolio`]);
    } else {
      this.router.navigate([`/activegames`]);
    }
  }

  hoveredResource: any = null;
  tooltipStyle: any = {};

  showResourceTooltip(event: MouseEvent, item: any): void {
    if (!item) return;
    this.hoveredResource = typeof item === 'string' ? { name: item } : item;
    const target = event.currentTarget as HTMLElement;
    if (target) {
      const rect = target.getBoundingClientRect();
      const tooltipWidth = 330;
      const left = Math.max(10, rect.left - tooltipWidth - 15);
      const top = Math.max(10, Math.min(window.innerHeight - 240, rect.top - 20));
      this.tooltipStyle = {
        top: `${top}px`,
        left: `${left}px`
      };
    }
  }

  hideResourceTooltip(): void {
    this.hoveredResource = null;
  }

  isResourceField(key: string | any): boolean {
    const resourceKeys = [
      'Natural Resources',
      'Bonus Resources',
      'Farm Resources',
      'Mineral Resources',
      'Special Resources',
    ];
    return resourceKeys.includes(key);
  }

  splitResources(value: string | any): any[] {
    if (!value || value === 'None') return [];
    if (Array.isArray(value)) {
      return value.map((item) => {
        if (typeof item === 'string') {
          return { name: item, description: '', production: 0, economy: 0, rarity: 0, processing: 0 };
        }
        return item;
      });
    }
    if (typeof value === 'string') {
      if (value.toLowerCase() === 'none') return [];
      return value.split(',').map((v) => ({
        name: v.trim(),
        description: '',
        production: 0,
        economy: 0,
        rarity: 0,
        processing: 0
      }));
    }
    return [];
  }

  onResourceClick(resource: string): void {
    this.wikiService.openResourceWiki(resource);
  }

  isLinkField(key: string | any): boolean {
    const linkKeys = ['State', 'Province', 'Culture', 'Religion', 'Biome'];
    return linkKeys.includes(key);
  }

  navigateToDynamicLink(key: string | any, value: string | any): void {
    this.wikiService.openWiki(key, value, this.mapcode, this.map_name);
  }

  removeFromFavroite(record: FavoriteRecord) {
    this.isRemovingFavorite = record.wp_content_usage_id;

    this.dataService.saveContentToFavorites(this.userId, record.wp_content_usage_id).subscribe({
      next: (res: any) => {
        this.toastService.showSuccess(res.message, 'success');

        this.favoriteRecordsService.loadFavoriteRecords(this.userId, 'city', true);
      
          this.cdr.detectChanges();},
      error: () => {
        this.isRemovingFavorite = null;
      
          this.cdr.detectChanges();}
    });
  }
  navigateToCityNameWiki() {
    this.wikiService.openCityWiki(
      this.cityData['City Name'],
      this.mapcode,
      this.map_name,
    );
  }

  navigateToWikiWorld(map_name?: string) {
    this.wikiService.openMapWiki(this.mapcode, map_name || this.map_name);
  }

  getMapName(mapcode?: string): string {
    if (!this.map_name) {
      ;
      this.mapService.getMapList(this.userId, false);
      const mapName = this.mapListData.find(
        (map) => map.map_id === mapcode,
      )?.map_name;
      this.map_name = mapName;
      return this.map_name || 'Unnamed Map';
    } else return this.map_name;
  }

  toggleGMTools() {
    this.showMenu = false;
    this.selectedOption = 'GMTools';
    this.showItemDetailsBox = true;
  }

  addNote(isPrivate: boolean) {
    this.showMenu = false;
    this.showItemDetailsBox = false;
    this.selectedOption = '';
    this.openNoteModal(isPrivate, false);
  }

  openNoteModal(isPrivate: boolean, isFilter: boolean) {
    const modalRef = this.modalService.open(NoteListComponent, {
      centered: true,
      backdrop: 'static',
      size: 'md',
    });

    modalRef.componentInstance.game_id = this.game_id;
    modalRef.componentInstance.noteType = isPrivate ? 'private' : 'public';
    modalRef.componentInstance.isFilter = isFilter;
  }

  journalCheckBoxChange(event, childRecords) {
    const journalEntry = childRecords.find(
      (entry) => entry.id == event.target.value,
    );
    journalEntry.selected = event.target.checked;

    if (!journalEntry.selected) {
      this.mapService.removeRedLineOfPathCity(journalEntry);
    } else {
      this.mapService.addLineOfPathCity(journalEntry);
    }
  }

  buildElevationRange(data: any) {
    const elevation =
      data?.elevation > 0 ? data.elevation : (data?.depth ?? NaN);

    // Always build the base object first
    const result: Record<string, boolean> = this.elevationRanges.reduce(
      (acc, range) => {
        acc[range] = false;
        return acc;
      },
      {} as Record<string, boolean>,
    );

    // Explicit early return for invalid elevation
    if (typeof elevation !== 'number' || Number.isNaN(elevation)) {
      return result;
    }

    for (const range of this.elevationRanges) {
      const match = range.match(/-?\d+/g);
      if (!match || match.length < 2) continue;

      const min = Number(match[0]);
      const max = Number(match[1]);

      if (elevation >= min && elevation <= max) {
        result[range] = true;
        break;
      }
    }

    return result;
  }

  processBiomeRanges(data: any) {
    let biome: string = data?.biome ?? '';

    // Normalize input biome to Title Case
    biome = biome
      .toLowerCase()
      .trim()
      .split(/\s+/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
      ?.trim();

    // Build base result object (all false)
    const result: Record<string, boolean> = this.biomeRanges.reduce(
      (acc, range) => {
        acc[range] = false;
        return acc;
      },
      {} as Record<string, boolean>,
    );

    // If biome is empty or invalid, return all false
    if (!biome) {
      return result;
    }

    // Exact match → set true
    if (result.hasOwnProperty(biome)) {
      result[biome] = true;
    }

    return result;
  }

  buildUrbanLocationRange(data: any) { }

  redirectToGMList() {
    this.router.navigate(['/activegames'], {
      queryParams: {
        tab: 'createModal',
      },
    });
  }

  openPlaceContentModal() {
    this.showMenu = false;
    const modalRef = this.modalService.open(PlaceContentModalComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
    });

    modalRef.componentInstance.map_id = this.mapcode;
    modalRef.componentInstance.city_id = this.citycode;

    modalRef.result.then((selectedContent) => {
      if (selectedContent) {
        const payload = {
          wp_product_id: selectedContent.wp_product_id,
          content_id: selectedContent.id,
          wp_user_id: Number(this.userId),
          context: 'city' as const,
          map_id: this.mapcode,
          city_id: this.citycode,
          latitude: this.newClickedCoordinates ? this.newClickedCoordinates[0] : 0,
          longitude: this.newClickedCoordinates ? this.newClickedCoordinates[1] : 0,
          label: selectedContent.content_title
        };


        this.dataService.contentAttach(payload).subscribe({
          next: (res: any) => {
            this.toastService.showSuccess('Content placed.', 'success');
            this.getAllCityContentRecordsOfMapCity(); // Refresh pins
          
          this.cdr.detectChanges();},
          error: (err) => {
            console.error('Error attaching content:', err);
            this.toastService.showSuccess("We couldn't place this content. Please try again.", 'danger');
          
          this.cdr.detectChanges();}
        });
      }
    
          this.cdr.detectChanges();});
  }

  browseWpStore() {
    // Opens the store filtered to this map's genre (and the game's system,
    // like the world map does). The StoreLinkService opens the in-app store.
    this.showMenu = false;
    const gameId = this.game_id && this.game_id !== 'null' ? this.game_id : undefined;
    this.dataService.getMapGenre(this.mapcode, gameId).subscribe((data: any) => {
      if (data?.res) {
        const actualGenre = data.res
        this.storeLinks.openStore({ genre: actualGenre, system: data.game_system || this.game_system || undefined });
      }
      else {
        this.storeLinks.openStore();
      }
      this.cdr.detectChanges();
    }, () => {
      this.storeLinks.openStore();
      this.cdr.detectChanges();
    });
  }

  constructParam(genre: string) {
    const groupGenre = ['Science Fiction & Science Fantasy (Traveller, etc)', 'Modern & Horror (Call of Cthulhu, etc)', 'Fantasy (Dungeons & Dragons, etc)', 'Fantasy (Dungeons & Dragons, etc)']
    const paramsGenre = ['scifi', 'modern-horror', 'fantasy']
    const index = groupGenre.indexOf(genre);
    if (index !== -1) {
      return paramsGenre[index];
    }
    return '';
  }
}
